import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-app-role-list',
  templateUrl: './app-role-list.component.html',
  styleUrls: ['./app-role-list.component.scss'],
})
export class AppRoleListComponent extends BaseListCtl {
  public appId: number = 0;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator.config.get('endpoint.application.role'), locator, route);
    let _self = this;
    locator.getPathVariable(route, function (params: any) {
      _self.appId = params['appId'];
    });
    _self.form['applicationId'] = 0;
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.applicationId = data.applicationId;
    form.applicationName = data.applicationName;
  }

  override ngOnInit() {
    this.preload();
    this.search();
    this.getApplications();
  }

  /**
  * Contains applications
  */
  public applications: any = [];

  getApplications() {
    let _self = this;
    // get applications 
    let url = this.locator.getEndpoint('endpoint.user') + '/applications';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applications = res.result.data;
    });
  }

  public editRole(id: number) {
    let _self = this;
    super.get(id, function cb() {
      // _self.getApplications();
      // _self.getUsers();
    });
  }
}
